/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AreaWithPartnerAndCaretakerCreateManyV1Dto } from '../models/AreaWithPartnerAndCaretakerCreateManyV1Dto';
import type { AreaWithPartnerAndCaretakerDeleteManyV1Dto } from '../models/AreaWithPartnerAndCaretakerDeleteManyV1Dto';
import type { BatchManyResultV1Dto } from '../models/BatchManyResultV1Dto';
import type { ContractClauseV2Dto } from '../models/ContractClauseV2Dto';
import type { ContractFilterInnerV2Dto } from '../models/ContractFilterInnerV2Dto';
import type { ContractPaginatedV2Dto } from '../models/ContractPaginatedV2Dto';
import type { ContractSimplePaginatedV2Dto } from '../models/ContractSimplePaginatedV2Dto';
import type { ContractToDocumentV1Dto } from '../models/ContractToDocumentV1Dto';
import type { ContractV1Dto } from '../models/ContractV1Dto';
import type { CreateContractClauseV1Dto } from '../models/CreateContractClauseV1Dto';
import type { CreateContractV1Dto } from '../models/CreateContractV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { OrderByPropertyDto } from '../models/OrderByPropertyDto';
import type { OrderByRelationalPropertyDto } from '../models/OrderByRelationalPropertyDto';
import type { PartnerAndCaretakerPartyPatchManyV1Dto } from '../models/PartnerAndCaretakerPartyPatchManyV1Dto';
import type { PatchContractClauseV1Dto } from '../models/PatchContractClauseV1Dto';
import type { PatchContractV1Dto } from '../models/PatchContractV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContractsService {
  /**
   * @param requestBody
   * @returns ContractClauseV2Dto create entity
   * @throws ApiError
   */
  public static contractClauseControllerV1CreateV1(
    requestBody: CreateContractClauseV1Dto,
  ): CancelablePromise<ContractClauseV2Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/contracts/clauses',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns ContractClauseV2Dto a entity list
   * @throws ApiError
   */
  public static contractClauseControllerV1FindAllV1(): CancelablePromise<
    Array<ContractClauseV2Dto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contracts/clauses',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static contractClauseControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contracts/clauses',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid contractClauseId
   * @returns ContractClauseV2Dto the entity
   * @throws ApiError
   */
  public static contractClauseControllerV1FindOneV1(
    uuid: string,
  ): CancelablePromise<ContractClauseV2Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contracts/clauses/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid contractClauseId
   * @param requestBody
   * @returns ContractClauseV2Dto the update entity
   * @throws ApiError
   */
  public static contractClauseControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchContractClauseV1Dto,
  ): CancelablePromise<ContractClauseV2Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/contracts/clauses/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid contractClauseId
   * @returns ContractClauseV2Dto the entity
   * @throws ApiError
   */
  public static contractClauseControllerV1RemoveOneV1(
    uuid: string,
  ): CancelablePromise<ContractClauseV2Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contracts/clauses/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param contractId contractId
   * @returns ContractClauseV2Dto a entity list
   * @throws ApiError
   */
  public static contractClauseControllerV1FindManyByContractV1(
    contractId: string,
  ): CancelablePromise<Array<ContractClauseV2Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contracts/clauses/by-contract/{contractId}',
      path: {
        contractId: contractId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns ContractV1Dto create entity
   * @throws ApiError
   */
  public static contractControllerV1CreateV1(
    requestBody: CreateContractV1Dto,
  ): CancelablePromise<ContractV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/contracts',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @deprecated
   * @returns ContractV1Dto a entity list
   * @throws ApiError
   */
  public static contractControllerV1FindAllV1(): CancelablePromise<Array<ContractV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contracts',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static contractControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contracts',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param customerId customerId
   * @returns ContractV1Dto a entity list
   * @throws ApiError
   */
  public static contractControllerV1FindManyByCustomerV1(
    customerId: string,
  ): CancelablePromise<Array<ContractV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contracts/by-customer/{customerId}',
      path: {
        customerId: customerId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid contractId
   * @returns ContractV1Dto the entity
   * @throws ApiError
   */
  public static contractControllerV1FindOneV1(uuid: string): CancelablePromise<ContractV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contracts/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid contractId
   * @param requestBody
   * @returns ContractV1Dto the update entity
   * @throws ApiError
   */
  public static contractControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchContractV1Dto,
  ): CancelablePromise<ContractV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/contracts/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid contactId
   * @returns ContractV1Dto the entity
   * @throws ApiError
   */
  public static contractControllerV1RemoveOneV1(uuid: string): CancelablePromise<ContractV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contracts/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param actionsAvailable Indicates if there are actions available for the contract
   * @param customerId Filter contracts by customer ID
   * @param customerGroupId Filter contracts by customer group ID
   * @param partnerId Filter contracts by partner ID
   * @param partnerGroupId Filter contracts by partner group ID
   * @param pointOfSaleId Filter contracts by point of sale ID
   * @param filter Filter conditions for querying Point of Sales
   * @param orderBy Array of ContractBaseV2Dto order by properties (supports relations with dot-notation)
   * @param searchString A search string to filter ContractBaseV2Dto by given values.
   * @param page Page number (starts at 1). Used for paginated queries. Must be a positive integer.
   * @param limit Number of items per page. Must be between 5 and 500. Used for paginated queries.
   * @returns ContractPaginatedV2Dto a entity list wrapped with pagination result
   * @throws ApiError
   */
  public static contractControllerV2FindAllPaginatedV2(
    actionsAvailable?: boolean | null,
    customerId?: string | null,
    customerGroupId?: string | null,
    partnerId?: string | null,
    partnerGroupId?: string | null,
    pointOfSaleId?: string | null,
    filter?: ContractFilterInnerV2Dto | null,
    orderBy?: Array<OrderByRelationalPropertyDto> | null,
    searchString?: string | null,
    page?: number,
    limit?: number,
  ): CancelablePromise<ContractPaginatedV2Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/contracts',
      query: {
        actionsAvailable: actionsAvailable,
        customerId: customerId,
        customerGroupId: customerGroupId,
        partnerId: partnerId,
        partnerGroupId: partnerGroupId,
        pointOfSaleId: pointOfSaleId,
        filter: filter,
        orderBy: orderBy,
        searchString: searchString,
        page: page,
        limit: limit,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param actionsAvailable Indicates if there are actions available for the contract
   * @param customerId Filter contracts by customer ID
   * @param customerGroupId Filter contracts by customer group ID
   * @param partnerId Filter contracts by partner ID
   * @param partnerGroupId Filter contracts by partner group ID
   * @param pointOfSaleId Filter contracts by point of sale ID
   * @param filter Filter conditions for querying Point of Sales
   * @param orderBy Array of ContractSimpleV2Dto order by properties
   * @param searchString A search string to filter ContractBaseV2Dto by given values.
   * @param page Page number (starts at 1). Used for paginated queries. Must be a positive integer.
   * @param limit Number of items per page. Must be between 5 and 500. Used for paginated queries.
   * @returns ContractSimplePaginatedV2Dto a entity list wrapped with pagination result
   * @throws ApiError
   */
  public static contractControllerV2FindAllSimplePaginatedV2(
    actionsAvailable?: boolean | null,
    customerId?: string | null,
    customerGroupId?: string | null,
    partnerId?: string | null,
    partnerGroupId?: string | null,
    pointOfSaleId?: string | null,
    filter?: ContractFilterInnerV2Dto | null,
    orderBy?: Array<OrderByPropertyDto> | null,
    searchString?: string | null,
    page?: number,
    limit?: number,
  ): CancelablePromise<ContractSimplePaginatedV2Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/contracts/simple',
      query: {
        actionsAvailable: actionsAvailable,
        customerId: customerId,
        customerGroupId: customerGroupId,
        partnerId: partnerId,
        partnerGroupId: partnerGroupId,
        pointOfSaleId: pointOfSaleId,
        filter: filter,
        orderBy: orderBy,
        searchString: searchString,
        page: page,
        limit: limit,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param contractId The ID of the contract to assign areas to
   * @param requestBody Payload to assign areas to a contract
   * @returns BatchManyResultV1Dto create entity
   *
   * Assign areas to a contract
   * @throws ApiError
   */
  public static contractAreaControllerV1AssignAreasToContractV1(
    contractId: string,
    requestBody: AreaWithPartnerAndCaretakerCreateManyV1Dto,
  ): CancelablePromise<BatchManyResultV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/contracts/{contractId}/areas',
      path: {
        contractId: contractId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param contractId The ID of the contract to unassign areas from
   * @param requestBody Payload to unassign areas from a contract
   * @returns DeleteManyResultV1 Unassign areas from a contract (Deletes the connection between the area and the contract)
   * @throws ApiError
   */
  public static contractAreaControllerV1UnassignAreasFromContractV1(
    contractId: string,
    requestBody: AreaWithPartnerAndCaretakerDeleteManyV1Dto,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contracts/{contractId}/areas',
      path: {
        contractId: contractId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param contractId The ID of the contract to update contracting parties for
   * @param requestBody Payload to update contracting parties for areas assigned to a contract
   * @returns BatchManyResultV1Dto Update contracting parties (partner and caretaker) for areas assigned to a contract. This endpoint can be used to update the partner and caretaker for an area that is already assigned to the contract.
   * @throws ApiError
   */
  public static contractAreaControllerV1UpdatePartialContractingPartiesV1(
    contractId: string,
    requestBody: PartnerAndCaretakerPartyPatchManyV1Dto,
  ): CancelablePromise<BatchManyResultV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/contracts/{contractId}/parties',
      path: {
        contractId: contractId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param contractUuid
   * @param documentUuid
   * @returns ContractToDocumentV1Dto create entity
   * @throws ApiError
   */
  public static contractToDocumentControllerV1LinkDocumentV1(
    contractUuid: string,
    documentUuid: string,
  ): CancelablePromise<ContractToDocumentV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/contracts/{contractUuid}/document/{documentUuid}',
      path: {
        contractUuid: contractUuid,
        documentUuid: documentUuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param contractUuid
   * @param documentUuid
   * @returns ContractToDocumentV1Dto the entity
   * @throws ApiError
   */
  public static contractToDocumentControllerV1UnlinkDocumentV1(
    contractUuid: string,
    documentUuid: string,
  ): CancelablePromise<ContractToDocumentV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contracts/{contractUuid}/document/{documentUuid}',
      path: {
        contractUuid: contractUuid,
        documentUuid: documentUuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param contractUuid
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static contractToDocumentControllerV1UnlinkManyDocumentsV1(
    contractUuid: string,
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contracts/{contractUuid}/documents',
      path: {
        contractUuid: contractUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
}
